import { render } from "./PaywallVariantA.vue?vue&type=template&id=22f69d1e&scoped=true"
import script from "./PaywallVariantA.vue?vue&type=script&lang=js"
export * from "./PaywallVariantA.vue?vue&type=script&lang=js"

import "./PaywallVariantA.vue?vue&type=style&index=0&id=22f69d1e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f69d1e"]])

export default __exports__